import { isEmpty, promiseTry, test } from '~/utils/lib/core/prelude'
import { ERRORS as ACCOUNT_ERRORS } from '~/utils/infra/account/types'
import { useStore_account_session } from '~/stores/account/session'

/**
 * @name MFAProvider
 * @desc Singleton visitor helping to provide MFA token to request instance
 */
export const MFAProvider = {
  /**
   * @function visit
   * @param {import('~/utils/infra/account/request').default} self
   * @throws {Error}
   */
  visit(self) {
    return promiseTry(() => {
      const mfaToken = useStore_account_session().mfaToken

      if (isEmpty(mfaToken))
        throw new Error(ACCOUNT_ERRORS.NO_MFA_TOKEN)

      // @NOTE using `ACCOUNT_API_URL` environment variable rathen than
      // `ENVIRONMENT` as it more precise to determine this specific micro
      // service environment mode (production or else)
      const account_api = import.meta.env.VITE_ACCOUNT_API_URL
      const withPreprodSuffix = test(/preprod/, account_api)

      const headers = {
        ...(withPreprodSuffix && { 'mfa-preprod': mfaToken }),
        ...(!withPreprodSuffix && { mfa: mfaToken }),
      }

      self.setHeaders(headers)

      return self
    })
  }
}
